<template>
  <div style="display: contents">
    <tr>
      <td colspan="4" class="p-0 border-0"></td>
      <td colspan="7" class="p-0 border-0">
        <b-list-group>
          <b-list-group-item class="d-flex justify-content-around align-items-center bg-light p-0 mt-n1">
            <span class="text-danger" v-if="booking.status === 'cancelled' "><b>CNX</b></span>
              <template v-else>
                <span class="text-warning" v-if="item.supplier_status === 'option' "><b>OPT</b></span>
                <span class="text-success" v-else-if="item.supplier_status === 'confirmed'"><b>CONF</b></span>
                <span class="text-info" v-else><b>REQ</b></span>
              </template>
            <span class="p-2 mx-3 col-8">
              {{ item.short_description }}
            </span>
            <span class="p-2 text-center col-2">
              <b-btn variant="warning" size="sm" v-if="documentName"  @click="downloadDocument">
                {{ documentName }}
              </b-btn>
            </span>
          </b-list-group-item>
        </b-list-group>
      </td>
    </tr>
  </div>
</template>

<script>
import { getTravelDocument, downloadPdf } from 'b2b-common/services/api/document'

export default {
  name: 'BookingItemResult',
  props: ['item', 'booking', 'is_tour'],
  computed: {
    documentName () {
      if (this.is_tour) return ''
      if (this.item.is_flight || this.item.is_bus) return 'Bilet'
      if (this.item.is_hotel) return 'Voucher'
      return ''
    }
  },
  methods: {
    downloadDocument () {
      let type = 'Voucher'
      if (this.item.is_flight) type = 'Ticket'
      if (this.item.is_mondial) type = 'Policy'
      getTravelDocument({ type, item: this.item.id, booking: this.booking.id })
        .then(pdfData => {
          let fileName = 'voucher.pdf'
          if (this.item.is_flight || this.item.is_bus) fileName = 'bilet.pdf'
          if (this.item.is_mondial) fileName = 'polita.pdf'
          downloadPdf({ pdfData, fileName })
        })
    }
  }
}
</script>
